import router from '@/router/router';
import authService from '@/api/authentication/auth.service';
import moment from "moment";
import {LOCAL_STORAGE_SEARCHED_CAPTATIONS_POINTS, LOCAL_STORAGE_SEARCHED_EFFLUENTS_POINTS} from '../../helpers/local_storage_constants';

const state = {
    loggedIn: false,
    token: undefined,
    currentUser: undefined
};

const mutations = {
    setUserAuthenticated(state, data) {
        state.loggedIn = true;
        state.token = data;
    },
    setLoginFailure(state) {
        state.loggedIn = false;
        state.token = undefined;
        state.currentUser = undefined;
    },
    cleanUserAuthenticated(state) {
        state.loggedIn = false;
        state.token = undefined;
    },
    setCurrentUser(state, data) {
        state.currentUser = data;
    },
    cleanCurrentUser(state) {
        state.currentUser = undefined;
    }
};

const actions = {

    async signIn({ commit }, data) {

        const { email, password } = data;

        return authService.login(email, password).then(
            result => {
                let access_token = result.access_token;
                commit('setUserAuthenticated', { access_token });

                try {
                    // clears previous searches from old session - for a while until it clears old locationsId
                    localStorage.removeItem(LOCAL_STORAGE_SEARCHED_CAPTATIONS_POINTS);
                    localStorage.removeItem(LOCAL_STORAGE_SEARCHED_EFFLUENTS_POINTS);

                    let profile = result.profile;
                    const { roles } = profile.attributes;
                    profile.attributes.roles = roles ?? '';
                    profile.attributes.expires_in = result.expires_in
                    profile.attributes.timestamp = moment().format('YYYY-MM-DD HH:mm:ss')
                    commit('setCurrentUser', profile);
                } catch (error) {
                    commit('setCurrentUser', undefined);
                }

                router.push('/Home').catch(()=>{})

                return Promise.resolve(result);
            },
            error => {
                commit('setLoginFailure');
                switch(error.response.data.status) {
                    case 401: // Unauthorized
                        error.response.data.error = "Usuário e/ou senha inválidos!"
                        break;
                }

                throw new Error(error.response.data.error);
            }
        );
    },
    // eslint-disable-next-line no-unused-vars
    logOut({ commit }) {

        // provisional - force clear all cache databases
        indexedDB.deleteDatabase('infohidro-volume');
        indexedDB.deleteDatabase('infohidro-telemetry');
        indexedDB.deleteDatabase('infohidro-riak');
        indexedDB.deleteDatabase('infohidro-envresources');
        indexedDB.deleteDatabase('infohidro-forecast');
        indexedDB.deleteDatabase('infohidro-forecasts');
        indexedDB.deleteDatabase('infohidro-geosimepar');
        indexedDB.deleteDatabase('rest-telemetric-infohidro');
        indexedDB.deleteDatabase('forecasts-api-infohidro');
        indexedDB.deleteDatabase('rest-geobar-infohidro');
        indexedDB.deleteDatabase('infohidro-cluster-saic-summary');

        // clear searches before logout - for a while until it clears old locationsId
        localStorage.removeItem(LOCAL_STORAGE_SEARCHED_CAPTATIONS_POINTS);
        localStorage.removeItem(LOCAL_STORAGE_SEARCHED_EFFLUENTS_POINTS);

        authService.logout()
        commit('cleanUserAuthenticated');
        commit('cleanCurrentUser');
    }
};


const getters = {
    loggedIn: (state) => state.loggedIn && state.token,
    currentUser: (state) => state.currentUser
};

export default {
    state,
    mutations,
    actions,
    getters
}
